export default __webpack_public_path__ + "static/media/starChecked.77f9ecb4.svg";